import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {PermissionContainerModel} from '../../../../../models/aggregates/permissions';


@Injectable({
  providedIn: 'root'
})
export class PermissionService extends BaseApiTemplateService<PermissionContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'permissions';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'permissions';
    this.endpoint_path = Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + 'permissions';
    this.httpClient = http;
  }
}


